import React from 'react'
import "./second.css"
function Fourth() {
    return (

        <div className='d1 grind'>
 <div className='text2'>
            <span>
            runners need to
            </span>
            <span className='title'>
                grind
            </span>
            <span style={{marginTop:'20px'}}> to unlock progressive NFT elements such as Avatars, upperwears and bottomwears to participate in ZIPPY’s open and persistent world. </span>
            </div>
           <img src='grind.png'  style={{ height:'450',marginTop:'2vh'}}></img>
           <button className='btn'  href="#">Whitelist Me</button>

        </div>
    );
}


export default Fourth;